"use strict";

var Backbone = require("backbone");
var $ = require("jquery");
var _ = require("underscore");
Backbone.$ = $;

var DomUtil = require("../../common/utils/dom-util");
var PageView = require("./page-view");

var debug = require("debug")("views:DocumentView");

/**
 * DocumentView : display a pv5 document
 * Triggers
 * - "change:page-position" :
 * - "add:page-view"        :
 * - "render:page-view"
 * - "refresh:page-view"    : todo
 * - "remove:page-view"     : todo
 */
module.exports = Backbone.View.extend({

    model: null, // DocumentModel
    elWidth: 0, // width of main el
    elHeight: 0, // height of main el
    isPortrait: false, // interface orientation
    pageViews: null, // array of pageViews
    zoomMax: 1,
    zoomFav: 1,
    zoomStepMultiplier: 2, // multiplication du zoom sur zoom in / zoom out
    enable: true,
    startFit: null, // fit initial demandé
    tileHd: false,
    authorizedPages: null,
    embed: false, // en mode embed on désactive touch-action:none (bug de scroll à partir d'ios 14)
    hasPointerEvent: false,

    events: {
        "contextmenu": "preventDefault", // Disables context menu
        "MSHoldVisual": "preventDefault", // Disables visual
        //"touchmove": "preventDefault", // Stop page from panning on iPhone OS.
        "dragstart": "preventDefault", // disable Firefox's default drag and drop behavior
        "pointerdown": "onDragStart", // à commenter pour forcer l'utilisation des events touch
        "touchstart": "onDragStart",
        "webkitTransitionEnd": "onTransitionEnd",
        "transitionend": "onTransitionEnd"
    },

    /**
     * @param  {Object}         options
     * @param  {DocumentModel}  options.documentModel
     * @param  {Element}        options.el element to attach this view
     * @param  {String}         options.pageTemplate page placeholder underscore template (optional)
     * @param  {String}         options.pageAuthorizationTemplate page authorization template, underscore template (optional)
     */
    initialize: function (options) {
        var T = this;

        _.extend(T, options);

        T.hasPointerEvent = window.PointerEvent ? true : false;
        //T.hasPointerEvent = false; // à décommenter pour forcer l'utilisation des events touch

        T.pageViews = [];
        T._dragStartPoint = {
            x: 0,
            y: 0
        };
        T._dragStartLeft = 0;
        T._pendingPage = 0;
        T._pointers = {};


        T.listenTo(T.model, "sync", T.onDocumentLoaded);
        T.listenTo(T.model, "change:page", T.onPageChanged);

        T.$documentContainer = $("<div/>", {
            class: "container"
        });

        if (!T.embed) {
            T.$documentContainer.css("touch-action", "none");
        }

        debug(navigator.userAgent.toLowerCase());

        T.transitionStyle = DomUtil.styleSupport("transition");
    },

    isPageAuthorized: function (page) {
        var T = this;
        if (_.isArray(T.authorizedPages)) {
            return T.authorizedPages.indexOf(page) != -1;
        }
        else {
            return true;
        }
    },

    onDocumentLoaded: function () {
        var T = this;
        T.render();
    },

    onTransitionEnd: function (e) {
        var T = this;
        if (e.target == T.$documentContainer[0] && e.originalEvent.propertyName == "left" && T._pendingPage) {
            T.model.set("page", T._pendingPage);
            T.preloadNextPage(T._pendingPage);
            T.preloadPreviousPage(T._pendingPage);
            T.removeUnusedPages();
            T._pendingPage = 0;
        }
    },

    preventDefault: function (e) {
        e.preventDefault();
    },

    render: function () {
        var T = this;

        if (!T.model.fetched) {
            return;
        }

        T.$documentContainer.appendTo(T.el);

        debug("render");
        T.resize();
    },

    onPagePositionChanged: function (page_view) {
        this.trigger("change:page-position", page_view);
    },

    onPageZoomFavChanged: function (page_view) {
        this.zoomFav = page_view.zoomFav;
    },

    onPageRendered: function (page_view) {
        this.trigger("render:page-view", page_view);
    },

    /**
     * update elements sizes when a size or
     * @return {[type]} [description]
     */
    resize: function () {
        var T = this;
        if (!T.model.fetched) return;
        if (!T.enable) return;

        T.elHeight = T.$el.height();
        T.elWidth = T.$el.width();

        var prev_orientation = T.isPortrait;
        T.isPortrait = (T.elWidth < T.elHeight) ? true : false;

        var nbScreens = T.model.get("nbPages");

        if (T.pageViews.length && prev_orientation != T.isPortrait) {
            //
            T.pageViews.forEach(function (view) {
                T.unloadPage(view.page);
            });
            T.loadPage(T.model.get("page"));
        }

        T.$documentContainer.css({
            width: T.elWidth * nbScreens
        });

        T.refresh();
        T.scrollTo(T.pagePosition(T.model.get("page")), false);
    },

    onDragStart: function (e) {
        var T = this,
            new_page_x, new_page_y;
        //console.log("drag start doc "+e.type);
        //e.preventDefault();
        if (T._pendingPage) return;
        if (e.type == "touchstart" && T.hasPointerEvent) return; // ignore les events touch si le navigateur supporte les pointers events

        var nb_touches_before = Object.keys(T._pointers).length;

        if (T.hasPointerEvent) {
            T._pointers[e.originalEvent.pointerId] = {
                pageX: e.pageX,
                pageY: e.pageY
            };
            new_page_x = e.pageX;
            new_page_y = e.pageY;
        }
        else {
            var touches = e.originalEvent.changedTouches;
            for (var i = 0; i < touches.length; i++) {
                T._pointers[touches[i].identifier] = {
                    pageX: touches[i].pageX,
                    pageY: touches[i].pageY
                };
            }
            new_page_x = touches[0].pageX;
            new_page_y = touches[0].pageY;
        }

        debug("drag start " + Object.keys(T._pointers).length + " pointers");

        var keys = _.keys(T._pointers);

        if (keys.length == 1) {
            T._dragStartPoint.x = new_page_x;
            T._dragStartPoint.y = new_page_y;
            T._dragStartLeft = -T.pagePosition(T.model.get("page"));
        } else {
            T._abortDrag = true;
        }

        if (nb_touches_before == 0) {
            if (T.hasPointerEvent) {
                $(window).on("pointermove.pv5-doc", function (e) {
                    T.onDragMove(e);
                });
                $(window).on("pointerup.pv5-doc", function (e) {
                    T.onDragEnd(e);
                });
                $(window).on("pointercancel.pv5-doc", function (e) {
                    T.onDragEnd(e);
                });
            }
            else {
                $(window).on("touchmove.pv5-doc", function (e) {
                    T.onDragMove(e);
                });
                $(window).on("touchend.pv5-doc", function (e) {
                    T.onDragEnd(e);
                });
                $(window).on("touchcancel.pv5-doc", function (e) {
                    T.onDragEnd(e);
                });
            }
        }

        //console.log(T._dragStartPoint.x+" "+T._dragStartPoint.x+" "+T._dragStartLeft);
    },

    onDragMove: function (e) {
        var T = this,
            new_page_x;
        //e.preventDefault();
        if (T._abortDrag) return;

        var page_view = T.currentPageView();

        //console.log("drag move doc "+e.type);
        if (T.hasPointerEvent) {
            T._pointers[e.originalEvent.pointerId] = {
                pageX: e.pageX,
                pageY: e.pageY
            };
            new_page_x = e.pageX;
        }
        else {
            var touches = e.originalEvent.changedTouches;
            for (var i = 0; i < touches.length; i++) {
                T._pointers[touches[i].identifier] = {
                    pageX: touches[i].pageX,
                    pageY: touches[i].pageY
                };
            }
            new_page_x = touches[0].pageX;
        }

        var keys = _.keys(T._pointers);
        if (keys.length == 1) {
            T.$el.addClass("grabbing");
            if (page_view) {
                if (!page_view.isZoomed()) {
                    T.scrollTo(-T._dragStartLeft + (T._dragStartPoint.x - new_page_x), false);
                }
            }
        }
    },

    onDragEnd: function (e) {
        var T = this;

        if (T.hasPointerEvent) {
            delete T._pointers[e.originalEvent.pointerId];
        }
        else {
            var touches = e.originalEvent.changedTouches;
            for (var i = 0; i < touches.length; i++) {
                delete T._pointers[touches[i].identifier];
            }
        }

        var keys = _.keys(T._pointers);

        //console.log("drag end doc "+e.type);
        debug("drag end " + Object.keys(T._pointers).length + " pointers");

        var left = T.$documentContainer[0].offsetLeft,
            delta = T._dragStartLeft - left,
            tolerance = 40,
            page = T.model.get("page"),
            last_page = T.model.get("nbPages"),
            abort = false;

        if (T._abortDrag) {
            abort = true;
        } else {
            //console.log("drag end doc");
            if (Math.abs(delta) < tolerance) {
                abort = true;
            } else {
                if (delta > 0) {
                    if (page == last_page) {
                        abort = true;
                    } else {
                        T.gotoPage("next", true);
                    }
                } else if (delta < 0) {
                    if (page == 1) {
                        abort = true;
                    } else {
                        T.gotoPage("previous", true);
                    }
                }
            }
        }
        if (abort) {
            T.scrollTo(-T._dragStartLeft, true);
        }
        if (!keys.length) {
            $(window).off(".pv5-doc");
            T._abortDrag = false;
            T.$el.removeClass("grabbing");
        }
    },

    /**
     * zoom current page
     * @param  {String|Number} zoom  command ("in"|"out"|"fit") or value (0->1)
     * @param  {Bool} animated
     */
    zoom: function (zoom, animated) {
        var T = this,
            page_view = T.currentPageView();
        page_view.zoom(zoom, animated);
    },


    isZoomed: function () {
        var T = this;
        return T.currentPageView().isZoomed();
    },

    /**
     * Return current page view from pageviews array
     * @return {PageView}
     */
    currentPageView: function () {
        var T = this;
        var p = T.model.get("page");
        if (T.model.get("isDouble") && !T.isPortrait) {
            if (p > 1) {
                p = (p % 2) ? p - 1 : p;
            }
        }
        return _.findWhere(T.pageViews, {
            page: p
        });
    },

    /**
     * move to a page
     * @param  {String|Number} page  a page
     * @param  {Bool} animated
     * @param  {Object} fitted_rectangle rectangle to fit in view {"x":"200","y":"200","w":"300","h":"400"}
     *
     */
    gotoPage: function (page, animated, fitted_rectangle) {

        var T = this,
            page_dest = 0,
            current = T.model.get("page"),
            nbPages = T.model.get("nbPages");

        if (T._pendingPage) return;

        if (_.isString(page)) {
            if (page == "previous") {
                if (T.model.get("isDouble") && !T.isPortrait) {
                    page_dest = (current % 2) ? current - 3 : current - 2;
                } else {
                    page_dest = current - 1;
                }
            } else if (page == "next") {
                if (T.model.get("isDouble") && !T.isPortrait) {
                    page_dest = (current % 2) ? current + 1 : current + 2;
                } else {
                    page_dest = current + 1;
                }
            } else {
                page_dest = parseInt(page, 10);
            }
        } else {
            page_dest = page;
        }

        // clamp
        if (page_dest > nbPages) {
            page_dest = nbPages;
        } else if (page_dest < 1) {
            page_dest = 1;
        }

        T.loadPage(page_dest, fitted_rectangle);

        // make destination the official current page at the end of animation
        T._pendingPage = page_dest;

        // now scroll
        T.scrollTo(T.pagePosition(page_dest), animated);
    },

    /**
     * load or preload a page and construct the view
     */
    loadPage: function (p, startFit) {
        var T = this;

        if (T.model.get("isDouble") && !T.isPortrait) {
            if (p > 1) {
                p = (p % 2) ? p - 1 : p;
            }
        }

        var page_view = _.findWhere(T.pageViews, {
            page: p
        });

        if (!page_view) {
            // create page view and append it to document container
            page_view = new PageView({
                page: p,
                startFit: startFit,
                documentModel: T.model,
                template: T.pageTemplate,
                authorizationTemplate: T.pageAuthorizationTemplate,
                authorizationMessage: T.pageAuthorizationMessage,
                zoomMax: T.zoomMax,
                zoomFav: T.zoomFav,
                zoomStepMultiplier: T.zoomStepMultiplier,
                isPortrait: T.isPortrait,
                tileHd: T.tileHd,
                authorizedPage: T.isPageAuthorized(p)
            });

            T.listenTo(page_view, "change:position", T.onPagePositionChanged);
            T.listenTo(page_view, "change:zoom-fav", T.onPageZoomFavChanged);
            T.listenTo(page_view, "render", T.onPageRendered);
            T.pageViews.push(page_view);

            page_view.$el.css({
                left: T.pagePosition(p),
                width: T.elWidth,
                height: T.elHeight
            });

            T.$documentContainer.append(page_view.el);
            T.trigger("add:page-view", page_view);
            page_view.render();
        } else {
            page_view.zoomFav = T.zoomFav;
            T.onPagePositionChanged(page_view); //generate a position changed
        }
    },

    unloadPage: function (p) {
        var T = this;
        var page_view = _.findWhere(T.pageViews, {
            page: p
        });
        if (page_view) {
            T.stopListening(page_view);
            page_view.remove();
            page_view.close();
            T.pageViews = _.without(T.pageViews, page_view);
            debug("unload page " + p);
            T.trigger("remove:page-view", page_view);
        }
    },

    /**
     * construct next page view. A appeler dans les temps mort, en dehors d'une animation
     * @param  {Number} p the current page
     */
    preloadNextPage: function (p) {
        var T = this;
        // preload next page
        var page_preload;
        if (T.model.get("isDouble") && !T.isPortrait) {
            page_preload = p + 2;
        } else {
            page_preload = p + 1;
        }
        if (page_preload <= T.model.get("nbPages")) {
            T.loadPage(page_preload);
        }
    },

    preloadPreviousPage: function (p) {
        var T = this;
        // preload next page
        var page_preload;
        if (T.model.get("isDouble") && !T.isPortrait) {
            page_preload = p - 2;
        } else {
            page_preload = p - 1;
        }
        if (page_preload > 0) {
            T.loadPage(page_preload);
        }
    },

    removeUnusedPages: function () {
        var T = this,
            page = T.model.get("page"),
            page_max, page_min;


        //compute page min / max
        if (T.model.get("isDouble") && !T.isPortrait) {
            page_max = page + 2;
            page_min = page - 2;
        } else {
            page_max = page + 1;
            page_min = page - 1;
        }

        T.pageViews.forEach(function (view) {
            if (view.page < page_min || view.page > page_max) {
                T.unloadPage(view.page);
            }
        });
    },

    /**
     * Called when page was changed in document model
     */
    onPageChanged: function () {
        var T = this;
        if (!T.enable) return;
        if (!T._pendingPage) {
            T.gotoPage(T.model.get("page"), false);
        }
    },

    /**
     * Update page view positions and size
     */
    refresh: function () {
        var T = this;
        T.pageViews.forEach(function (view) {
            view.$el.css({
                left: T.pagePosition(view.page),
                width: T.elWidth,
                height: T.elHeight,
                isPortrait: T.isPortrait
            });
            view.resize();
        });
    },

    /**
     * retrieve page position from page number and view configuration
     * @return {Number} page left position
     */
    pagePosition: function (page) {
        var T = this,
            pos = 0;

        if (T.model.get("isDouble")) {
            if (T.isPortrait) {
                pos = (page - 1) * T.elWidth;
            } else {
                var page_left = (page % 2) ? page - 1 : page; // left page
                pos = T.elWidth * (page_left / 2);
            }
        } else {
            pos = (page - 1) * T.elWidth;
        }

        return pos;
    },

    /**
     * scroll document container horizontally
     * @param  {[type]} position_x [description]
     * @param  {[type]} animated   [description]
     */
    scrollTo: function (position_x, animated) {
        var T = this,
            previous_left = T.$documentContainer.css("left"),
            the_css = {
                left: -position_x
            };

        the_css[T.transitionStyle] = animated ? "left 0.5s ease-out" : "none";
        //console.log("scroll to:"+position_x);
        T.$documentContainer.css(the_css);

        if (parseInt(previous_left) == parseInt(the_css.left) || !animated) {
            // generate a transition a fake event
            T.onTransitionEnd({
                target: T.$documentContainer[0],
                originalEvent: {
                    propertyName: "left"
                }
            });
        }

    },

    close: function () {
        var T = this;

        T.$documentContainer.remove();

        T.pageViews.forEach(function (view) {
            T.unloadPage(view.page);
        });

        $(window).off(".pv5-doc");

        T.stopListening();
        T.undelegateEvents();
    }

});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@immanens-com/pv5js/reader/views/document-view.js
// module id = 43
// module chunks = 0